export enum NewAgainLandingPageEvent {
  LandingPageView = 'user.view_landingpage_new_again',
  CtaClick = 'user.landingpage_new_again_click_cta',
  SecondCtaClick = 'user.landingpage_new_again_click_second_cta',
}

export const newAgainLandingPagePopulateParams = [
  'seo.og_image',
  'introduction_section',
  'potential_section.cards.image',
  'for_nowever_section.image',
  'for_nowever_section.image_mobile',
  'feel_new_again_section',
]
